import Link from 'next/link'
import {NextRouter} from 'next/router'
import React from 'react'
import {useTheme} from 'styled-components'
import {Box, Button} from '@miro-site/core'

type ButtonType = React.ComponentProps<typeof Button>

type Props =
  | {
      href: Parameters<NextRouter['push']>[0]
      as?: Parameters<NextRouter['push']>[1]
      onClick?: never
    }
  | {
      as?: never
      href?: never
      onClick: ButtonType['onClick']
    }

const CallToAction: React.FC<
  {
    children: React.ReactNode
    beforeSlot?: React.ReactNode
    isFixed?: boolean
  } & Props
> = ({href, as, onClick, children, beforeSlot, isFixed = true}) => {
  const theme = useTheme()
  return (
    <Box
      $styles={
        isFixed
          ? {
              position: 'fixed',
              bottom: theme.spaces.xl,
              left: 0,
              right: 0,
              padding: 'inherit',
            }
          : null
      }
    >
      {beforeSlot ? beforeSlot : null}
      {href ? (
        <Link href={href} as={as} passHref legacyBehavior>
          <Button
            $size="medium"
            $styles={{
              width: '100%',
            }}
            $buttonType="primary"
          >
            {children}
          </Button>
        </Link>
      ) : (
        <Button
          $size="medium"
          $styles={{
            width: '100%',
          }}
          onClick={onClick}
          $buttonType="primary"
        >
          {children}
        </Button>
      )}
    </Box>
  )
}

export default CallToAction
